import React from 'react';

import { useMediaQuery, useTheme } from '@material-ui/core';

import { customSpinnerStyles } from './CustomSpinner.styles';
import { ICustomSpinner } from './CustomSpinnerTypes';

const CustomSpinner: React.FC<ICustomSpinner> = () => {
	const classes = customSpinnerStyles();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<div className={classes.containerLoader}>
			<div
				className={
					isMobile
						? `${classes.loader}`
						: `${classes.loader} ${classes.loaderDesktop}`
				}
			/>
		</div>
	);
};

export default CustomSpinner;
